// client/src/components/ErrorBoundary.jsx
import React from 'react';
import { reportClientError, shortCode } from '../lib/clientLog';
import '../styles/ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      rid: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React error:', error, errorInfo);
    const rid = reportClientError('react', error, { component_stack: errorInfo?.componentStack });
    this.setState({
      error,
      errorInfo,
      rid
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
      rid: null
    });
    // Optionally reload the page
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-content">
            <h1>⚠️ خطایی رخ داده است</h1>
            <p>متأسفانه مشکلی در بارگذاری برنامه پیش آمده است.</p>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="error-details">
                <summary>جزئیات خطا (فقط در حالت توسعه)</summary>
                <pre>{this.state.error.toString()}</pre>
                {this.state.errorInfo && (
                  <pre>{this.state.errorInfo.componentStack}</pre>
                )}
              </details>
            )}

            {this.state.rid && (
              <p className="error-tracking-code">
                کد پیگیری: <bdi dir="ltr">{shortCode(this.state.rid)}</bdi>
              </p>
            )}

            <div className="error-actions">
              <button onClick={() => window.location.reload()} className="error-reset-button">
                بارگذاری دوباره
              </button>
              <button onClick={this.handleReset} className="error-reset-button">
                بازگشت به صفحه اصلی
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
